/**
 * Bottom padding that clears the iPhone home indicator.
 *
 * `viewport-fit=cover` (index.html) lets the document draw into the safe areas, so every
 * bottom-anchored surface of the counting flow — the layout's scroll container, the review
 * footer, a drawer footer — adds the inset to its own padding. `env()` resolves to 0 wherever
 * there is no inset, so the same style is correct on desktop.
 */
export function safeAreaBottom(base: string) {
  return { paddingBottom: `calc(${base} + env(safe-area-inset-bottom))` }
}
